import React, { useEffect, useState } from 'react';

import { Redirect } from 'react-router-dom';
import { AuthConsumer } from '../../../context/AuthContext';

function Logout({ logout }) {
    const [done, setDone] = useState(false);

    useEffect(() => {
        let alive = true;
        (async () => {
            await logout('manual');
            if (alive) setDone(true);
        })();
        return () => { alive = false; };
    }, [logout]);

    return done ? <Redirect to="/login" /> : null;
}

export default function LogoutWithContext(props) {
    return (
        <AuthConsumer>
            {({ logout }) => <Logout {...props} logout={logout} />}
        </AuthConsumer>
    );
}
